import { Component } from './component.js';

export class ControlButtonContainer extends Component {
  static defaultOptions = {
    componentName: 'ControlButtonContainer'
  };

  constructor (options) {
    super($.extend({}, ControlButtonContainer.defaultOptions, options));
  }

  hide () {
    this.el.css('opacity', 0);
  }

  show () {
    this.el.css('opacity', 1);
  }
}
